import RoomConfigure from "./RoomConfigure";

export default RoomConfigure;
